import { siteName } from "@/mocks/chigua";
import Reveal from "./Reveal";

const principles = [
  {
    icon: "ri-search-eye-line",
    title: "追得真",
    desc: "不搬运、不拼接，素材交叉核对，尽量还原事实边界，而非放大情绪。",
  },
  {
    icon: "ri-flashlight-line",
    title: "够得新",
    desc: "全天候跟进热点，第一时间呈现话题动态，吃瓜就要吃最新最猛的。",
  },
  {
    icon: "ri-shield-check-line",
    title: "守得住",
    desc: "尊重个体边界，演绎内容明确标注，不做无中生有的中伤与诱导。",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100 md:rounded-3xl">
            <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr]">
              {/* 左：定位 */}
              <div className="relative flex flex-col justify-center overflow-hidden bg-primary-600 p-7 text-background-50 md:p-10">
                <span className="pointer-events-none absolute -right-10 -top-10 font-heading text-[180px] font-black leading-none text-background-50/10 select-none">
                  “
                </span>
                <p className="font-label text-xs font-bold uppercase tracking-[0.25em] text-accent-300">
                  About {siteName}
                </p>
                <h2 className="rule-head mt-4 font-heading text-2xl font-black leading-snug md:text-3xl">
                  把每一口瓜，吃清楚、说完整
                </h2>
                <p className="mt-5 max-w-lg text-sm leading-relaxed text-background-100 md:text-[15px]">
                  {siteName}
                  是一份专注娱乐与热门话题的资讯读物。我们把镜头对准聚光灯内外，也关心热搜之下的真实生活——从明星娱乐、影视综艺到网络热点、职场与电竞，用编辑部式的克制笔触，陪你看懂每一个正在发生的热点。
                </p>
                <a
                  href="mailto:hello@chiguatoutiao.cn"
                  className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 font-label text-sm font-bold text-primary-700 transition hover:bg-accent-400 hover:text-foreground-950"
                >
                  <i className="ri-mail-send-line"></i>
                  联系我们 · 投稿线索
                </a>
              </div>

              {/* 右：三大原则 */}
              <div className="flex flex-col justify-center gap-4 p-7 md:p-10">
                <h3 className="font-heading text-xl font-black text-foreground-950">我们坚持的原则</h3>
                {principles.map((p) => (
                  <div
                    key={p.title}
                    className="flex items-start gap-4 rounded-lg bg-background-50 p-4 ring-1 ring-background-200"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-800">
                      <i className={p.icon}></i>
                    </span>
                    <div>
                      <p className="font-heading text-base font-bold text-foreground-950">{p.title}</p>
                      <p className="mt-1 text-[13px] leading-relaxed text-foreground-600">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}